export const UJIKOM_ENABLED_GROUP = 'pemetaan-kompetensi-sjt'
